import React from "react";
import { setMemoria } from "../../tools/auxiliar";
import { Container, Row, Col, Button} from "react-bootstrap";
import { logout } from "../../services/oAuth";

import "./styles.css";

export default function Logout({ history }) {

  const login = localStorage.getItem("Login");
  
  // apaga memória
  setMemoria("","", false);
 
  // Logout no GOVBR

  if (login === 'GOVBR'){
    setMemoria("","", false);
    logout();
  }
  // Volta Página Inicial
  function handleConfirmar(){
    window.location="/";
  }

    return (
      <>
        <Container>
          <Row>
            <Col sm={12}>
              <div className="voltar">
                <a href={"/"}>voltar</a>
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm="12" align="center">
              <br /><br /><br /><br />
              <h3>Obrigado pela sua contribuição!</h3>
            </Col>
          </Row>
          <Row>
            <Col sm="12" align="center" className="naoMostrar">
              <br /><br /><br /><br />
              <Button variant="success" onClick={handleConfirmar}>Avaliação</Button>

            </Col>
          </Row>
        </Container>
      </>
    );
}